import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import LicenseForm from './LicenseForm';
import Confirmation from './Confirmation';
import { showConfirmation } from '../../actions';

function StaticContent() {
  return (
    <div className="tv-aiTalk__information-wrapper__content">
      <h1 className="tv-aiTalk__information-wrapper__content-title-main">
        TFV AI‑Tolk
      </h1>
      <h5 className="tv-aiTalk__information-wrapper__content-description">
        TFV AI‑Tolk är ett användarvänligt AI‑baserat tolkverktyg för enklare
        kommunikation. Ett värdeskapande verktyg som ökar möjligheten till vård
        och bemötande på lika villkor. TFV AI-Tolk är ett komplement till den
        mänskliga tolken.
      </h5>
      <h2 className="tv-aiTalk__information-wrapper__content-title">
        Så fungerar TFV AI‑Tolk
      </h2>
      <h5 className="tv-aiTalk__information-wrapper__content-description">
        TFV AI‑Tolk kan både tala och skriva. Användaren väljer själv om den
        vill tala eller skriva, lyssna eller läsa. Verktyget har en inbyggd
        kontrollfunktion som möjliggör för användaren att säkerställa korrekt
        översättning.
      </h5>
      <h2 className="tv-aiTalk__information-wrapper__content-title">
        Användningsområden
      </h2>
      <h5 className="tv-aiTalk__information-wrapper__content-description">
        TFV AI-Tolk är särskilt utvecklat för att användas vid enklare
        vardagssamtal med till exempel inneliggande patienter i sjukvården,
        vårdtagare i omsorgen, vårdnadshavare inom barnomsorgen men också
        anhöriga och vårdnadshavare i såväl sjukvårds- som omsorgssituationer.
        Verktyget kan även underlätta vid till exempel provtagning eller i en
        reception.
      </h5>
      <h2 className="tv-aiTalk__information-wrapper__content-title">
        Säkerhet
      </h2>
      <h5 className="tv-aiTalk__information-wrapper__content-description">
        Verktyget efterlever GDPR och Patientdatalagen och säkerställer
        patientsekretess genom säker datahantering. Ingen information sparas,
        all data raderas direkt efter att konversationen avslutats. Verktyget
        tränas inte på konversationsdata. All data är krypterad och servrarna
        finns inom EU.
      </h5>
      <h2 className="tv-aiTalk__information-wrapper__content-title">
        Tekniska förutsättningar
      </h2>
      <h5 className="tv-aiTalk__information-wrapper__content-description">
        TFV AI‑Tolk kräver internetuppkoppling och fungerar på smartphone och
        surfplatta (tillverkade efter 2021) samt dator. Verktyget är en
        progressiv webbapp och nås via valfri webbläsare.
      </h5>
      <h2 className="tv-aiTalk__information-wrapper__content-title">
        Licens och tillgång
      </h2>
      <h5 className="tv-aiTalk__information-wrapper__content-description">
        För att få tillgång till TFV AI‑Tolk tecknas en licens. Licensen
        debiteras månadsvis och kopplas till samma kundnummer som används för
        övriga tjänster. När licensen är tecknad ges tillgång till verktyget.
        Inloggning sker med användarnamn och lösenord som skapas av användaren.
      </h5>
      <h2 className="tv-aiTalk__information-wrapper__content-title">
        Uppsägning
      </h2>
      <h5 className="tv-aiTalk__information-wrapper__content-description">
        Uppsägning av licensen ska ske senast den 5:e i månaden för att tjänsten
        ska avslutas vid nästkommande månadsskifte.
      </h5>
      <h2 className="tv-aiTalk__information-wrapper__content-title">Kontakt</h2>
      <h5 className="tv-aiTalk__information-wrapper__content-description">
        Vid frågor maila:{' '}
        <a
          href="mailto:info@tolkformedlingvast.se"
          className="tv-aiTalk__information-wrapper__content-description-url"
        >
          info@tolkformedlingvast.se
        </a>
      </h5>
    </div>
  );
}

function AboutAITolk({
  licenses = [],
  showConfirmationMessage = false,
  hideConfirmation = () => {},
}) {
  const navigate = useNavigate();
  const [showConfirmationModal, setShowConfirmationModal] =
    React.useState(false);
  const existingLicenseIdsRef = React.useRef([]);

  if (!showConfirmationModal && !showConfirmationMessage) {
    existingLicenseIdsRef.current = licenses.map(l => l.LicenseIdentifier);
  }

  useEffect(() => {
    if (showConfirmationMessage) {
      setShowConfirmationModal(true);
    }
  }, [showConfirmationMessage]);

  const handleGoToCreateUser = () => {
    const newLicense = licenses.find(
      l => !existingLicenseIdsRef.current.includes(l.LicenseIdentifier),
    );
    if (newLicense) {
      navigate('/ai-tolk/users', {
        state: {
          tabIndex: 1,
          licenseIdentifier: newLicense.LicenseIdentifier,
          numberOfActiveUsers: newLicense.NumberOfActiveUsers,
          numberOfLicenses: newLicense.NumberOfLicenses,
          dateFirstCancellationPossible:
            newLicense.DateFirstCancellationPossible,
          licenseTypeName: newLicense.LicenseTypeName,
        },
      });
    } else {
      navigate('/ai-tolk/users', {
        state: { tabIndex: 1 },
      });
    }
  };

  return (
    <>
      <div className="tv-aiTalk__panel-wrapper">
        <div className="tv-aiTalk__information-wrapper">
          <StaticContent />
          <div className="tv-aiTalk__information-wrapper__content">
            <h5 className="tv-aiTalk__information-wrapper__content-title-main">
              Komma igång med TFV AI-Tolk steg för steg:
            </h5>
            <ol className="tv-aiTalk__information-wrapper__content-list">
              <li>Teckna Licens</li>
              <li>Gå till ”Hantera licens” och skapa användare</li>
            </ol>
            <h6 className="tv-aiTalk__information-wrapper__content-paragraph">
              Läs gärna igenom{' '}
              <span
                onClick={() => navigate('/ai-tolk', { state: { tabIndex: 2 } })}
                className="tv-aiTalk__information-wrapper__content-paragraph-link"
              >
                användarinstruktionerna
              </span>
            </h6>
            <div className="tv-aiTalk__license-form">
              <LicenseForm displayConfirmation={true} />
            </div>
            <p className="mt-5">
              För mer information kontakta{' '}
              <a href="mailto:info@tolkformedlingvast.se" className="tv-aiTalk__information-wrapper__content-description-url">
                info@tolkformedlingvast.se
              </a>
            </p>
          </div>
        </div>
      </div>
      <Confirmation
        isVisible={showConfirmationModal}
        onClose={() => {
          setShowConfirmationModal(false);
          hideConfirmation();
        }}
        onGoToCreateUser={handleGoToCreateUser}
      />
    </>
  );
}

const mapStateToProps = state => ({
  licenses: state.user.profile.licenses || [],
  showConfirmationMessage: state.user.showConfirmation,
});
const mapDispatchToProps = dispatch => ({
  hideConfirmation: () => {
    dispatch(showConfirmation(false));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AboutAITolk);
